<select class="form-select" [(ngModel)]="model" id="role" name="role" (ngModelChange)="eventChange()">
  <option [ngValue]="'SECRETARY'">Segretaria</option>
  <option [ngValue]="'AGENT'">Agente</option>
  <option [ngValue]="'AGENCY_ADMIN'">Responsabile Agenzia</option>
  <option [ngValue]="'OWNER'">Titolare</option>
  <option [ngValue]="'ADMIN'">Amministratore</option>
</select>